import React, { createContext, useContext, useState, useCallback } from "react";

// import { Toast, ToastContainer } from "react-bootstrap";
import Alert from "components/Alert";

const AlertContext = createContext();
/**
 * Hook para utilizar o contexto de alertas
 * 
 * @example
 * import { useAlert } from "context/AlertContext";
 * 
 * const Component = () => {
 *  const { showAlert, hideAlert } = useAlert();
 *  const handleClick = () => {
 *   showAlert("Mensagem de alerta", "success");
 * };
 * 
 *  return <button onClick={handleClick}>Clique aqui</button>;
 * };
 * 
 * 
 * @returns 
 */
const useAlert = () => {
  return useContext(AlertContext);
};

const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState({
    show: false,
    message: "",
    variant: "success",
  });

  const showAlert = useCallback((message, variant = "success") => {
    setAlert({ show: true, message, variant });
  }, []);

  const hideAlert = useCallback(() => {
    setAlert((prev) => ({ ...prev, show: false }));
  }, []);

  return (
    <AlertContext.Provider value={{ showAlert, hideAlert }}>
      {children}
      <Alert hideAlert={hideAlert} alert={alert} />
    </AlertContext.Provider>
  );
};

export { AlertProvider, useAlert };
